import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["analytics", "className", "rowHover", "fixedHeader", "maxHeight"];
import React from 'react';
import classNames from 'classnames';
import { Impression, ImpressionContext // @ts-expect-error -- No types!
} from '@nerdwallet/analytics/react/impression';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { BaseTable } from './BaseTable';
import { TableContainer } from './TableContainer';
import styles from './Table.module.less';

/**
 * The standard NerdWallet table.
 */
export var Table = function Table(_ref) {
  var analytics = _ref.analytics,
      className = _ref.className,
      rowHover = _ref.rowHover,
      fixedHeader = _ref.fixedHeader,
      maxHeight = _ref.maxHeight,
      props = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedClassNameStylePropsWarning('Table', {
    className: className,
    style: props.style
  });
  return /*#__PURE__*/React.createElement(Impression, {
    entityName: "table_scroll_h",
    enabled: analytics === null || analytics === void 0 ? void 0 : analytics.enabled
  }, /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return /*#__PURE__*/React.createElement(TableContainer, {
      analytics: analytics,
      impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
      fixedHeader: fixedHeader,
      maxHeight: maxHeight
    }, /*#__PURE__*/React.createElement(BaseTable, _extends({
      "data-currency": "Table"
    }, props, {
      fixedHeader: fixedHeader,
      className: classNames(className, _defineProperty({}, styles.rowHover, rowHover))
    })));
  }));
};